import { render } from "./UploadFile.vue?vue&type=template&id=d5ec8014"
import script from "./UploadFile.vue?vue&type=script&lang=js"
export * from "./UploadFile.vue?vue&type=script&lang=js"
script.render = render

export default script